import { motion } from 'framer-motion';
import { FaLeaf, FaGlobe, FaHandsHelping } from 'lucide-react';

export default function HomePageSections() {
  return (
    <div className="space-y-12 p-6">
      {/* Woman's Right to Safe Periods */}
      <motion.section 
        className="bg-pink-100 rounded-2xl p-8 shadow-xl flex flex-col md:flex-row items-center gap-6"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="flex-1">
          <h2 className="text-3xl font-bold text-pink-700">A Woman’s Right to Safe Periods</h2>
          <p className="mt-4 text-lg text-gray-700">
            Every woman deserves a **rash-free, chemical-free period**. Traditional pads contain harmful chemicals that cause irritation and disrupt hormones. Our organic pads are made with **pure cotton** and **biodegradable materials**, ensuring comfort, safety, and a healthier future.
          </p>
          <p className="mt-4 text-lg text-gray-700">
            **You are not just choosing a pad. You are choosing your health, self-care, and empowerment.**
          </p>
          <button className="mt-6 px-6 py-3 bg-pink-600 text-white font-semibold rounded-lg shadow-md hover:bg-pink-700 transition">
            Choose Organic, Choose You
          </button>
        </div>
        <img src="https://images.unsplash.com/photo-1712842955521-55c8c01ef148?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8b3JnYW5pYyUyMHNhbml0YXJ5JTIwcGFkc3xlbnwwfHwwfHx8MA%3D%3D" alt="Woman's Health" className="w-full md:w-1/2 rounded-xl shadow-lg" />
      </motion.section>
      
      {/* Save Earth, Save Ourselves */}
      <motion.section 
        className="bg-green-100 rounded-2xl p-8 shadow-xl flex flex-col md:flex-row items-center gap-6"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <img src="https://images.unsplash.com/photo-1706535426949-e90f953f0d6d?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NjZ8fGNvdHRvbiUyMG5hdHVyYWwlMjBzYW5pdGFyeSUyMHBhZHxlbnwwfHwwfHx8MA%3D%3D" alt="Save Earth" className="w-full md:w-1/2 rounded-xl shadow-lg" />
        <div className="flex-1">
          <h2 className="text-3xl font-bold text-green-700">Save Earth, Save Ourselves</h2>
          <p className="mt-4 text-lg text-gray-700">
            Did you know that **one traditional pad takes 500+ years to decompose**? Imagine the waste we are leaving behind. By switching to **organic, biodegradable pads**, you are making a difference for future generations.
          </p>
          <p className="mt-4 text-lg text-gray-700">
            **Be a part of the change. Protect your body and protect the planet.**
          </p>
          <button className="mt-6 px-6 py-3 bg-green-600 text-white font-semibold rounded-lg shadow-md hover:bg-green-700 transition">
            Join the Movement
          </button>
        </div>
      </motion.section>
    </div>
  );
}
